import classNames from 'classnames';
import {Link} from 'react-router';
import React, {useCallback} from 'react';

import {Icon, Tab} from '@albert-io/atomic';
import type {IconProp} from '@albert-io/atomic/atoms/Icon/Icon.react';

interface TabConfig {
  icon: IconProp;
  label: string;
  to: string;
}

interface Props extends PropsWithClassNameOptional {
  classroomId?: string;
  pathname: string;
}

export default function StudentHomepageTabs({className, classroomId, pathname}: Props) {
  const getTabTo = useCallback(
    (suffix: string) => {
      let to = '/home';

      if (classroomId !== undefined) {
        to = `${to}/class/${classroomId}`;
      }

      to = `${to}/${suffix}`;

      return to;
    },
    [classroomId]
  );

  const tabConfigs: TabConfig[] = [
    {
      icon: ['fal', 'file-alt'],
      label: 'Assignments',
      to: getTabTo('assignments')
    },
    {
      icon: ['fal', 'sparkles'],
      label: 'Skill Path',
      to: getTabTo('skill-path')
    },
    {
      icon: ['fal', 'pencil'],
      label: 'Independent Practice',
      to: getTabTo('independent-practice')
    }
  ];

  return (
    <div
      className={classNames(
        'flex items-start overflow-x-auto rounded-t-3xl border-b border-b-border-primary background-primary',
        className
      )}
    >
      {tabConfigs.map(({icon, label, to}) => (
        <Tab
          as={Link}
          className='px-x2 py-x1'
          contentWrapperClassName='flex gap-x1 items-center'
          isActive={pathname.includes(to)}
          key={to}
          to={to}
        >
          <Icon icon={icon} />
          {label}
        </Tab>
      ))}
    </div>
  );
}
